"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _HeaderSkeleton = require("./HeaderSkeleton");
Object.keys(_HeaderSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HeaderSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _HeaderSkeleton[key];
    }
  });
});
